import { useState, useEffect } from 'react';

const IntroScreen = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Auto close intro after 7 seconds
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        onComplete();
      }, 1000);
    }, 7000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  const handleVideoEnd = () => {
    setFadeOut(true);
    setTimeout(() => {
      onComplete();
    }, 1000);
  };

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-black transition-opacity duration-1000 ${
        fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* Video Background - Full Screen */}
      <video
        autoPlay
        muted
        playsInline
        preload="auto"
        onEnded={handleVideoEnd}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ objectFit: 'cover' }}
      >
        <source
          src="https://customer-assets.emergentagent.com/job_career-destination/artifacts/cxmlsnfz_WhatsApp%20Video%202026-07-14%20at%2003.29.33.mp4"
          type="video/mp4"
        />
      </video>

      {/* Dark overlay for better text visibility */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70"></div>

      {/* Animated Text - Rising from bottom */}
      <div className={`absolute inset-0 flex flex-col items-center justify-end pb-32 transition-all duration-[3000ms] ${
        fadeOut ? 'translate-y-[-100vh] opacity-0' : 'translate-y-0 opacity-100'
      }`}>
        <div className="text-center space-y-6 animate-fade-in">
          {/* Main Title */}
          <div className="text-[#D4AF37] text-7xl font-bold tracking-wider drop-shadow-2xl">
            ARYA MOHAJER ASIA
          </div>
          
          {/* Subtitle */}
          <div className="text-white text-3xl font-light tracking-wide opacity-90">
            مسیر آینده شما از اینجا آغاز می‌شود
          </div>
          
          {/* Decorative line */}
          <div className="w-64 h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent mx-auto"></div>
        </div>
      </div>

      {/* Skip button */}
      <button
        onClick={() => {
          setFadeOut(true);
          setTimeout(() => onComplete(), 500);
        }}
        className="absolute bottom-8 left-8 px-6 py-2 text-white/70 hover:text-white border border-white/30 hover:border-white/70 rounded-full transition-all duration-300 text-sm"
      >
        رد شدن
      </button>
    </div>
  );
};

export default IntroScreen;
